export interface ParsedBlockDescription {
  subType: string;
  text: string;
}

/**
 * Parses sub-type prefix from block description (e.g., "[Pers. Admin] Monthly expense reports").
 * Uses deterministic string slicing for linear O(N) performance without regex backtracking.
 */
export function parseBlockDescription(description: string, subTypes: string[] = []): ParsedBlockDescription {
  if (!description || !description.startsWith('[')) {
    return { subType: '', text: description || '' };
  }

  const closeBracketIndex = description.indexOf(']');
  if (closeBracketIndex <= 1) {
    return { subType: '', text: description };
  }

  const candidate = description.slice(1, closeBracketIndex);
  if (subTypes.includes(candidate)) {
    const remainder = description.slice(closeBracketIndex + 1).trimStart();
    return { subType: candidate, text: remainder };
  }

  return { subType: '', text: description };
}

/**
 * Formats sub-type and description text into standardized `[Sub-Type] text` string.
 */
export function formatBlockDescription(subType: string, text: string): string {
  const trimmedText = text.trim();
  if (subType && trimmedText) {
    return `[${subType}] ${trimmedText}`;
  }
  if (subType) {
    return `[${subType}]`;
  }
  return trimmedText;
}
